import { useEffect } from 'react';
import { useAppSelectSearch } from './hooks/useAppSelectSearch';

interface Props {
  onSearch: (search: string) => void;
}

/**
 * Bridges `AppSelectContent`'s internal search state out to a parent callback
 * (e.g. for server-side search / pagination reset). Must render inside
 * `AppSelectContent` so the `useAppSelectSearch` hook runs within its context —
 * placing it directly in a parent would call the hook outside the provider.
 */
export function SearchBridge({ onSearch }: Props) {
  const search = useAppSelectSearch();
  useEffect(() => {
    onSearch(search);
  }, [search, onSearch]);
  return null;
}
